import {
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_ERROR,
    CHANGE_PASSWORD_REQUEST,
    RESET_CHANGE_PASSWORD
} from "../../Actions/EndUser/AuthActions";
import { auth } from "../../../services";

const initialState = {
    error: '',
    submitting: false,
    email: auth.getAuthUserEmail(),
    reset: false
}

export const changePassword = (state = initialState, action) => {
    
    switch (action.type) {
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                error: '',
                submitting: false,
                reset: true
            }
        case CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                error: action.payload,
                submitting: false
            }
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                error: '',
                submitting: true
            }
        case RESET_CHANGE_PASSWORD:
        return {
            ...state,
            reset: false
        }
        default:
            return state;
    }
}